import React from "react";
import {
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import "../FormClose/FormClose.css";
import Smallbutton from "../button/Smallbutton";
import img from "../../assets/kangaroo/goldbg.png"

const FormGoldBg = ({ modal, toggle, closeBtn, description, heading}) => {
  return (
    <Modal
      isOpen={modal}
      toggle={toggle}
     style={{ maxWidth: "629px", width: "90%" }}

    >
      <div  style={{
      backgroundImage: `url(${img})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      borderRadius: "8px",
      padding: "20px",
      width: "100%",
      height: "100%"
    }}>

    

      <ModalBody>
        <Container
          fluid
          className="w-75 d-flex flex-column justify-content-center m-0 "
          style={{ height: "85vh" }}
        >
          {/* This wrapper will center the two rows as a single block */}
          <div className="d-flex flex-column  align-items-start ">
            <Row className="text-left mb-3 ms-4 ">
              <Col>
                <div>
                  <h1 className="thankyou-font-gold">Thank You</h1>
                  <h1 className="thankyou-desc">{heading}</h1>
                  <p className="thankyou-trail">{description}</p>
                </div>
              </Col>
            </Row>

            <Row className="mb-3 ms-4">
              <Col className="d-flex justify-content-center">
                <div
                 
                  onClick={toggle}
                >
                  <Smallbutton fill="#fff" text="CLOSE"  width = "200" strokeWidth={0}/>
                
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </ModalBody>
      </div>
    </Modal>
  );
};

export default FormGoldBg;
